import { CounterType } from '@gripp/shared-logic';
import { useRef } from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { useFormContext } from '../../forms';
import { CounterTypeComponents } from './counterTypeMap';

export type CounterExecutionComponentBaseProps = {
  formKeyPrefix?: string;
  instructions: string;
  initialValue: number;
  value: number;
  onChange: (value: number) => void;
  onBlur: () => void;
  autoFocus?: boolean;
  decimalPlaces?: number;
  containerStyle?: StyleProp<ViewStyle>;
  inputContainerStyle?: StyleProp<ViewStyle>;
  pillToggleContainerStyle?: StyleProp<ViewStyle>;
  counterType?: CounterType;
  isIssueEditRoutine?: boolean;
  /** Locks the input — set when an integration owns this counter's value. */
  disabled?: boolean;
};

export type CounterExecutionComponentProps =
  CounterExecutionComponentBaseProps & {
    inputRef: any;
    onFocus: any;
    fieldName: string;
  };

export const CounterExecutionComponent = (
  props: CounterExecutionComponentBaseProps
) => {
  const inputRef = useRef<any>({});

  const fieldName = props.formKeyPrefix
    ? `${props.formKeyPrefix}.count`
    : 'count';

  const { watch } = useFormContext();
  const currentValue = watch(fieldName);

  const autoFocus = props.autoFocus === undefined ? true : props.autoFocus;

  const setCursorToEnd = () => {
    const num = currentValue ?? 0;
    const length = num.toString().length;
    const selection = { end: length, start: length };
    inputRef.current &&
      inputRef.current.setNativeProps &&
      inputRef.current.setNativeProps({
        selection: selection,
      });
    setTimeout(() => {
      inputRef.current &&
        inputRef.current.setNativeProps &&
        inputRef.current.setNativeProps({ selection: null });
    }, 0);
  };
  const counterType = getCounterType(props);
  const CounterTypeComponent = CounterTypeComponents[counterType];

  return (
    <CounterTypeComponent
      {...props}
      inputRef={inputRef}
      fieldName={fieldName}
      autoFocus={autoFocus}
      onFocus={setCursorToEnd}
    />
  );
};

const getCounterType = (props: CounterExecutionComponentBaseProps) => {
  if (!props.counterType) return CounterType.Simple;
  const validKeys: Record<string, keyof typeof CounterType> = {
    SIMPLE: 'Simple',
    CUMULATIVE: 'Cumulative',
    TALLY: 'Tally',
  };

  const enumKey = validKeys[props.counterType];

  if (enumKey) {
    return CounterType[enumKey];
  }

  return CounterType.Cumulative;
};
